import apiClient from './apiClient';

class ReportsService {
    /**
     * Fetches AI-generated performance summaries for the team.
     * Uses the centralized apiClient which handles Entra auth automatically.
     */
    async fetchTeamPerformanceAISummary({ startDate, endDate, filters, teamData, forceRefresh = false }, signal) {
        try {
            const result = await apiClient.post('/reports/team_performance/ai', {
                start_date: startDate,
                end_date: endDate,
                filters,
                team_data: teamData,
                force_refresh: forceRefresh
            }, { signal });

            return result;
        } catch (error) {
            if (error.name === 'AbortError' || error.name === 'CanceledError') {
                throw error;
            }
            console.error('Error fetching AI summaries:', error);
            throw error;
        }
    }
}

export const reportsService = new ReportsService();
export default ReportsService;
